"use client";

import { lazy } from "react";
import type { ToolUIRegistry } from "../../tool-renderer";

/**
 * Views for the read-only Concur expense line-item tools (list, detail,
 * itemizations). Keyed by bare tool name.
 */
export const concurExpenseToolRegistry = {
  concurListExpenses: {
    kind: "standalone",
    category: "research",
    view: lazy(() =>
      import("./expense-views").then(({ ConcurListExpensesToolView }) => ({
        default: ConcurListExpensesToolView,
      }))
    ),
  },
  concurGetExpense: {
    kind: "standalone",
    category: "research",
    view: lazy(() =>
      import("./expense-views").then(({ ConcurGetExpenseToolView }) => ({
        default: ConcurGetExpenseToolView,
      }))
    ),
  },
  concurGetItemizations: {
    kind: "standalone",
    category: "research",
    view: lazy(() =>
      import("./expense-views").then(({ ConcurGetItemizationsToolView }) => ({
        default: ConcurGetItemizationsToolView,
      }))
    ),
  },
} satisfies ToolUIRegistry;
